import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';

export const SpeakerDialog = ({ speaker, onClose }) => (
  <Dialog open={!!speaker} onOpenChange={(o) => !o && onClose()}>
    <DialogContent
      data-testid="speaker-dialog"
      className="w-[calc(100vw-1.5rem)] max-w-3xl max-h-[90dvh] overflow-y-auto overscroll-contain p-0 bg-[#0f0a17] border-white/10 text-white rounded-3xl [&>button]:text-white [&>button]:bg-black/60 [&>button]:rounded-full [&>button]:p-1.5 [&>button]:right-3 [&>button]:top-3 [&>button]:opacity-100 [&>button]:z-10"
    >
      {speaker && (
        <div className="grid grid-cols-1 md:grid-cols-5">
          <div className="md:col-span-2 relative h-56 sm:h-72 md:h-auto md:min-h-[520px]">
            <img src={speaker.image} alt={speaker.name} className="absolute inset-0 w-full h-full object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0f0a17] via-transparent to-transparent md:bg-gradient-to-r" />
            {speaker.photoCredit && (
              <span className="absolute bottom-2 left-3 text-[10px] text-white/50">Foto: {speaker.photoCredit}</span>
            )}
          </div>
          <div className="md:col-span-3 p-5 sm:p-7 md:p-10 flex flex-col min-w-0">
            <p className="text-[#ff2e2e] font-semibold uppercase tracking-widest text-xs mb-2">{speaker.role} på Refuel Weekend 27</p>
            <DialogTitle className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-4 md:mb-5" style={{ fontFamily: "'Oktah Round', sans-serif" }} data-testid="speaker-dialog-title">
              {speaker.name}
            </DialogTitle>
            <DialogDescription asChild>
              <div className="space-y-3 md:space-y-4 text-white/80 leading-relaxed text-sm sm:text-base" data-testid="speaker-dialog-bio">
                {speaker.bio.map((p, i) => <p key={i}>{p}</p>)}
              </div>
            </DialogDescription>
            {speaker.socials?.length > 0 && (
              <div className="mt-6 md:mt-auto pt-4 md:pt-8">
                <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-3">Følg {speaker.name.split(' ')[0]} i sosiale medium</p>
                <div className="flex gap-3">
                  {speaker.socials.map((s) => {
                    const Icon = s.type === 'instagram' ? Instagram : Facebook;
                    return (
                      <a key={s.type} href={s.href} target="_blank" rel="noreferrer noopener" data-testid={`speaker-social-${s.type}`} className="w-11 h-11 rounded-full border border-white/15 text-white/70 hover:bg-[#ff2e2e] hover:border-[#ff2e2e] hover:text-black flex items-center justify-center transition-colors">
                        <Icon size={18} />
                      </a>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
